"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _SttButton = _interopRequireDefault(require("./SttButton/SttButton"));
var _SttHeading = _interopRequireDefault(require("./SttTypography/SttHeading"));
var _SttModal = _interopRequireDefault(require("./SttModal"));
var _axios = _interopRequireDefault(require("axios"));
var _SttCheckbox = _interopRequireDefault(require("./SttInput/SttCheckbox"));
var _SttFormControlLabel = _interopRequireDefault(require("./SttForm/SttFormControlLabel"));
var _SttCard = _interopRequireDefault(require("./SttSurfaces/SttCard"));
var _SttCardContent = _interopRequireDefault(require("./SttSurfaces/SttCardContent"));
var _SttAlerta = _interopRequireDefault(require("./SttAlerta"));
var _SttLoading = _interopRequireDefault(require("./SttLoading"));
var _SttNotification = _interopRequireDefault(require("./SttSurfaces/SttNotification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    heading: {
      marginBottom: theme.spacing(0.5),
      marginTop: theme.spacing(1)
    },
    divConteudo: {
      overflow: 'auto',
      // lineBreak: 'anywhere',
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5)
    },
    card: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  };
});
function SttNotificationScreen(props) {
  var strings = props.strings,
    headers = props.headers,
    config = props.config,
    _props$perfisRBAC = props.perfisRBAC,
    perfisRBAC = _props$perfisRBAC === void 0 ? [] : _props$perfisRBAC;
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    notificacoes = _useState4[0],
    setNotificacoes = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    salvando = _useState6[0],
    setSalvando = _useState6[1];
  var _useState7 = (0, _react.useState)(perfisRBAC.some(function (p) {
      return p.identificador.includes('admin');
    })),
    _useState8 = _slicedToArray(_useState7, 1),
    ehAdmin = _useState8[0];
  var handleCloseAlerta = function handleCloseAlerta() {
    setMostrarAlerta(false);
  };
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    mostrarAlerta = _useState10[0],
    setMostrarAlerta = _useState10[1];
  var _useState11 = (0, _react.useState)(strings.sucesso),
    _useState12 = _slicedToArray(_useState11, 2),
    tituloAlerta = _useState12[0],
    setTituloAlerta = _useState12[1];
  var _useState13 = (0, _react.useState)('success'),
    _useState14 = _slicedToArray(_useState13, 2),
    tipoAlerta = _useState14[0],
    setTipoAlerta = _useState14[1];
  var _useState15 = (0, _react.useState)(strings.sucesso),
    _useState16 = _slicedToArray(_useState15, 2),
    mensagemAlerta = _useState16[0],
    setMensagemAlerta = _useState16[1];
  var _useState17 = (0, _react.useState)(function () {
      return handleCloseAlerta;
    }),
    _useState18 = _slicedToArray(_useState17, 2),
    onCloseAlerta = _useState18[0],
    setOnCloseAlerta = _useState18[1];
  var _useState19 = (0, _react.useState)([{
      title: strings.ok,
      onClick: handleCloseAlerta
    }]),
    _useState20 = _slicedToArray(_useState19, 2),
    opcoesAlerta = _useState20[0],
    setOpcoesAlerta = _useState20[1];
  (0, _react.useEffect)(function () {
    listarNotificacoes();
  }, []);
  function listarNotificacoes() {
    _axios["default"].get("".concat(config.url_base_mensagens, "/notificacao-usuario?modulo=").concat(config.modulo_sigla), {
      headers: headers
    }).then(function (response) {
      if (response.data.data) {
        var notific = response.data.data;
        if (notific.totalRegistros > 0) {
          setNotificacoes(notific.itens);
          setOpen(true);
          return;
        }
        setOpen(false);
      }
    })["catch"](function (err) {
      return console.log(err);
    });
  }
  function handleCloseModal() {
    setOpen(false);
  }
  function confirmarLeitura() {
    var mensagensLidas = [];
    notificacoes.forEach(function (n) {
      if (n.lida) {
        mensagensLidas.push(n._id);
      }
    });
    setSalvando(true);
    _axios["default"].post("".concat(config.url_base_mensagens, "/notificacao-leitura"), {
      mensagensLidas: mensagensLidas
    }, {
      headers: headers
    }).then(function (response) {
      setTipoAlerta('success');
      setTituloAlerta(strings.sucesso);
      setMensagemAlerta(response.data.message);
      setOpcoesAlerta([{
        title: strings.ok,
        onClick: function onClick() {
          listarNotificacoes();
          setMostrarAlerta(false);
        }
      }]);
      setOnCloseAlerta(function () {
        return function () {
          listarNotificacoes();
          setMostrarAlerta(false);
        };
      });
      setMostrarAlerta(true);
    })["catch"](function (err) {
      return console.log(err);
    })["finally"](function () {
      setSalvando(false);
    });
  }
  function desabilitarConfirmarLeitura() {
    return notificacoes.every(function (n) {
      return !n.lida;
    });
  }
  function handleClick(event) {
    // Verifica se o elemento clicado é um link
    if (event.target.tagName.toLowerCase() === 'a') {
      // Abre o link em uma nova aba
      window.open(event.target.href, '_blank');
      // Impede o comportamento padrão do link (navegar para outra página)
      event.preventDefault();
    }
  }
  ;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttAlerta["default"], {
    open: mostrarAlerta,
    title: tituloAlerta,
    message: mensagemAlerta,
    type: tipoAlerta,
    options: opcoesAlerta,
    onClose: onCloseAlerta
  }), /*#__PURE__*/_react["default"].createElement(_SttLoading["default"], {
    open: salvando
  }), /*#__PURE__*/_react["default"].createElement(_SttModal["default"], {
    title: strings.notificacoes,
    open: open,
    maxWidth: "lg",
    fullWidth: true,
    children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, notificacoes && notificacoes.length > 0 && notificacoes.map(function (n, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index
      }, /*#__PURE__*/_react["default"].createElement(_SttCard["default"], {
        variant: "outlined",
        className: classes.card
      }, /*#__PURE__*/_react["default"].createElement(_SttCardContent["default"], null, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
        variant: "h3",
        className: classes.heading,
        color: "primary"
      }, n.envio.assunto), /*#__PURE__*/_react["default"].createElement("div", {
        onClick: handleClick,
        className: classes.divConteudo
      }, /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: n.envio.conteudo
        }
      })), n.envio.bloqueioTela && !ehAdmin ? /*#__PURE__*/_react["default"].createElement(_SttNotification["default"], {
        severity: "warning"
      }, strings.atencao, "!\xA0", strings.avisoMensagemBloqueia) : /*#__PURE__*/_react["default"].createElement(_SttFormControlLabel["default"], {
        required: true,
        control: /*#__PURE__*/_react["default"].createElement(_SttCheckbox["default"], {
          color: "primary",
          checked: !!n.lida,
          onChange: function onChange(evt, value) {
            notificacoes[index].lida = evt.target.checked;
            setNotificacoes(_toConsumableArray(notificacoes));
          }
        }),
        label: strings.liCiente
      }))));
    })),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      variant: "contained",
      color: "primary",
      onClick: confirmarLeitura,
      disabled: desabilitarConfirmarLeitura()
    }, strings.confirmarLeitura), (!notificacoes.some(function (n) {
      return n.envio.leituraObrigatoria || n.envio.bloqueioTela;
    }) || ehAdmin) && /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      variant: "contained",
      color: "primary",
      onClick: handleCloseModal
    }, strings.fechar))
  }));
}
var _default = SttNotificationScreen;
exports["default"] = _default;